export function toAnnualConsumptionWithTemporal(
    annualConsumption: { allDay: number } | { peak: number; offPeak: number }
) {
    if ("allDay" in annualConsumption) {
        return [{ temporalClass: "BASE" as const, consumption: annualConsumption.allDay }]
    }

    return [
        { temporalClass: "HP" as const, consumption: annualConsumption.peak },
        { temporalClass: "HC" as const, consumption: annualConsumption.offPeak },
    ]
}
